import { useQuery } from '@tanstack/react-query';
import {
  getLabourItemGroupDetails,
  LabourItemGroupDetails,
} from '../api/labourItemGroupsApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { labourGroupKeys } from './labourGroupKeys';

export const useGroupDetails = (
  groupId: string | null,
  enabled: boolean = true
) => {
  const token = useAuthStore(state => state.token);

  return useQuery<LabourItemGroupDetails | null>({
    queryKey: groupId
      ? labourGroupKeys.detail(groupId)
      : labourGroupKeys.details(),
    queryFn: async () => {
      if (!groupId || !token) return null;
      return await getLabourItemGroupDetails(groupId);
    },
    enabled: enabled && !!groupId && !!token,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
